import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const meridianIvory: Collection = {
  id: 's-and-p-meridian-ivory',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Meridian Ivoor',
  subTitle: 'Stijlvol en feestelijk',
  banner: 'meridian-ivory/meridian_ivory_banner.jpg',
  items: [
    {
      id: 's-and-p-meridian-ivory-1',
      collectionImages: [
        {
          image: 'meridian-ivory/Meridian_ivory_aura_blossom_villa_04.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 's-and-p-meridian-ivory-2',
      collectionImages: [
        {
          image: 'meridian-ivory/Meridian_ivory_aura_blossom_villa_05.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'meridian-ivory/Meridian_ivory_aura_blossom_villa_ferno_01.jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '63fa8a3e-76d6-43c8-8a04-6b8417363e45',
    'ded741df-4e8b-461f-828d-2886aa929c9a',
    '5a6ad9cc-61b6-4d23-91b1-c771d5406ef4',
    'a858be3d-5787-4568-a549-2e4969f5b137',
    'b8e3d99e-699c-47d8-94cb-2f231115b0b8',
    '4e896c9a-866a-4d27-a021-6b63d80e8b5a',
    '42f17cf7-d992-4634-b3ac-ca2b0c7430ae',
    'b6295cdc-49ee-416d-aec7-bb9cd8426080',
    '581761c5-3989-4eea-b45c-1c91ba7b38e1',
    '44f1eefa-db56-48fb-8c13-56fd858de871',
    'cc3fea6c-5f87-4a78-98be-3faa1b05c9b6',
    '594b686a-a761-4f02-b921-14f6b63777ef',
    'a7d5f94f-a4c3-4537-8e92-7871f5b10cc4',
    'dcba0d2f-4d63-4052-a651-c8d84d6c5628',
    '03ac773a-0470-491c-81a6-c724e73d68ac',
    'cf9e6533-04c3-413e-b07a-8764bf251224',
    'd616e993-e072-4dfa-8a57-88145c83a704',
    'aceedebb-6117-4657-a063-a58c2299d12c',
    'a7334e39-b496-4f4c-9202-ca7c10c32d7f'
  ]
};
